module.exports = __webpack_public_path__ + "FixelText-Medium.c2366d29e15db5120bd4.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fixelText/FixelText-Medium.woff2
// module id = ./src/assets/webfonts/fixelText/FixelText-Medium.woff2
// module chunks = styles